export enum RefillTypes {
  REGULAR = "REGULAR",
  FIRST_FILL = "FIRST_FILL",
}
